<template>
  <div><qyzz /></div>
</template>

<script>
// 获取接口地址
import Qyzz from '@/components/qyzz/qyzz'
export default {
  name: 'Wldw',
  components: { Qyzz },
  data() {
    return {}
  },
  created() {
    console.log(this.$route.params.id)
  },
  methods: {}
}
</script>

<style scoped>
</style>
